import React from 'react';

import { Subject } from '../../clients/AnalyticsClient';
import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';
import { captureException } from '../../sentry';

interface Props {
  children: React.ReactNode;
  fallback?: JSX.Element;
  onError?: (subject: string, error: Error, errorInfo: React.ErrorInfo) => void;
  subject: Subject;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props & AnalyticsConsumerProps, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    const { analytics, subject, onError } = this.props;
    this.setState({ hasError: true });
    captureException(error, { error_type: `${subject} errorBoundary` });
    analytics
      .trackOperational(subject, 'error', {
        error,
        errorInfo,
      })
      .catch(e => captureException(e, { error_type: 'analytics-track' }));

    if (typeof onError === 'function') {
      onError(subject, error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }

    return this.props.children;
  }
}

export default withAnalytics(ErrorBoundary);
